import axios from "axios";
import { getTenant } from "./TENANT_CONFIGS";

export const getWebSocketEndpoint = () => {
  if(process.env.NODE_ENV === 'production'){
    return import.meta.env.VITE_SYNC_ENGINE_URL;
  }else{
    // console.log({SYNC: import.meta.env.VITE_SYNC_ENGINE_URL})
    // return import.meta.env.VITE_SYNC_ENGINE_URL;
    return 'http://localhost:3001'
  }
}
